import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["claimButton", "claimForm"]

  connect() {
    console.log("DeployClaimController connected")
  }

  showClaimForm(event) {
    event.preventDefault()
    this.claimButtonTarget.style.display = 'none'
    this.claimFormTarget.style.display = 'flex'
  }

  hideClaimForm(event) {
    event.preventDefault()
    this.claimFormTarget.style.display = 'none'
    this.claimButtonTarget.style.display = 'block'
  }
}

